export default __webpack_public_path__ + "static/media/error-hexagon.83918780.svg";